import { BaseLink } from '@src/components/base/Link'
import { GRAMMAR, PLAGIARISM } from '@src/components/Cards/constants'
import { ListItem } from '@src/components/List'
import { Params } from '@src/pages/Workspace/types'
import { recheck } from '@src/state/document/actions'
import { EXPERT_CHECK } from '@src/state/document/types'
import { isDemoSelector } from '@src/state/router/selectors'
import { RootState } from '@src/state/types'
import { selectCurrentCheckCategory, tabs } from '@src/state/workspace/selectors'
import { RECHECK_GRAMMAR, RECHECK_PLAGIARISM } from '@src/utils/dataTestIds'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { Dispatch } from 'redux'
import styled from 'styled-components'
import { getCheckCategoryPath } from '../NavTabs/utils'
import { MenuItem } from '../styles'
import * as Types from './types'

const RecheckBaseLink = styled(BaseLink)`
  color: ${({ theme }) => theme.colors.dark};
  &:hover {
    text-decoration: none;
  }
`

interface StateToProps {
  isExpertCheck: boolean
  isDemo: boolean
}

interface DispatchProps {
  checkGrammar: () => void
  checkPlagiarism: () => void
}

export const RecheckMenuitems: React.FunctionComponent<StateToProps &
  Types.RecheckMenuItemsProps &
  RouteComponentProps<Params> &
  DispatchProps> = ({
  checkGrammar,
  checkPlagiarism,
  hasMinText,
  match,
  checksRunning,
  isExpertCheck,
  isDemo,
}) => {
  const grammarPlagiarismFilters = tabs.filter(
    ({ category }) => category === GRAMMAR || category === PLAGIARISM
  )
  return (
    <React.Fragment>
      {grammarPlagiarismFilters.map(({ category, displayText }) => {
        const callback = category === PLAGIARISM ? checkPlagiarism : checkGrammar
        const testId = category === PLAGIARISM ? RECHECK_PLAGIARISM : RECHECK_GRAMMAR
        const path = getCheckCategoryPath({
          paperId: match.params.id,
          checkCategory: category,
          isDemo,
        })
        return (
          <ListItem key={displayText}>
            <MenuItem
              as={RecheckBaseLink}
              to={path}
              onClick={callback}
              data-test={testId}
              disabled={isExpertCheck || !hasMinText || checksRunning}
            >
              Recheck {category}
            </MenuItem>
          </ListItem>
        )
      })}
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  checkPlagiarism: () => dispatch(recheck({ category: PLAGIARISM })),
  checkGrammar: () => dispatch(recheck({ category: GRAMMAR })),
})

const mapStateToProps = (state: RootState) => ({
  isExpertCheck: selectCurrentCheckCategory(state) === EXPERT_CHECK,
  isDemo: isDemoSelector(state),
})

const Rechecks = connect(mapStateToProps, mapDispatchToProps)(RecheckMenuitems)

export default withRouter(Rechecks)

Rechecks.displayName = 'Rechecks'



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/RecheckMenuitems.tsx